<div class="job-card v-card v-card--hover v-sheet theme--light" on style="{{cancelledStyle}}">
  {{#job}}
  <div class="v-card__text pa-2" style="border-left: 4px solid {{division.hexCode}}; ">
    <p class="textColor-black body-2 text-truncate mb-1">
      {{#activity}}
      <b>{{taskName}}</b>
      {{/activity}}
      {{details}}
    </p>

    <div class="row no-gutters align-center">
      <div class="col shrink text-truncate">{{destinationLocation}}</div>

      <div class="col align-end text-truncate text-right">
        <span style="padding: var(--space-smaller) var(--space-small);">#{{id}}</span>
        <span class="schedule-chip state" style="padding: var(--space-smallest) var(--space-small);
          border-radius: var(--space-base);">{{status}}</span>
      </div>
    </div>
  </div>
  {{/job}}

  {{#showProgressBar}}
  {{#currentProgress}}
  <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="{{currentProgress}}"
    style="position: relative; height: 7px; background-color: var(--color-silver); display: flex;">
    {{#progressSegments}}
    <div
      class= "progress-bar {{status}}"
      style="width: {{percent}}%;"></div>
    {{/progressSegments}}
  </div>
  {{/currentProgress}}
  {{/showProgressBar}}
</div>
